import React, { FC } from "react";
import { useGoogleAuth } from "src/hooks/useGoogleAuth";
import { Banner } from "src/page-components/home/Banner";
import { TrandingClones } from "src/page-components/home/TrandingClones";
import { UnlockOpportunities } from "src/page-components/home/UnlockOpportunities";
import { HowToBuy } from "src/page-components/home/HowToBuy";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { MetadataWrapper } from "src/components/MetadataWrapper";

const Home: FC = () => {
  useGoogleAuth();

  return (
    <MetadataWrapper name="home">
      <PageWrapper
        mainClassName="flex flex-col gap-5 gl:gap-10 pb-5 lg:pb-20"
        isShownHeader={false}
      >
        <Banner />
        <TrandingClones />
        <UnlockOpportunities />
        <HowToBuy />
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default Home;
